import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { Select } from 'common-src/components/base';

import usePopup from 'src/hooks/usePopup';
import { createMissingMemberPortalAccess } from 'src/pages/PatientDetails/fragments/PatientPortalAccess/services';
import BasePopup from 'src/popups/BasePopup';

import styles from './CreateMissingMemberPortalAccessPopup.module.scss';

const LIMIT_OPTIONS = [10, 20, 50, 100].map((value) => ({
  label: String(value),
  value,
}));

const CreateMissingMemberPortalAccessPopup = ({ onClose }) => {
  const [selectedLimit, setSelectedLimit] = useState(LIMIT_OPTIONS[0]);
  const { renderButtons } = usePopup();

  const onSubmitHandler = async (loadingCallback, successCallback, errorCallback) => {
    loadingCallback();

    try {
      const data = await createMissingMemberPortalAccess(selectedLimit.value);
      successCallback(data?.message || 'Bulk portal access job started.');
      onClose(true);
    } catch (error) {
      errorCallback(error.message || 'Failed to create bulk portal access.');
    }
  };

  return (
    <BasePopup
      id="create-missing-member-portal-access"
      open
      onClose={onClose}
      title="Bulk Portal Access"
    >
      <div className={styles.content}>
        <p className={styles.description}>
          Choose how many missing member portal access records to create.
        </p>
        <Select
          id="portal-access-limit"
          label="Limit"
          options={LIMIT_OPTIONS}
          onChange={setSelectedLimit}
          value={selectedLimit}
          required
          placeholder="Select limit"
        />
      </div>
      {renderButtons({
        containerClassName: styles.buttonsContainer,
        onClose,
        onSubmit: onSubmitHandler,
        isSubmitEnabled: Boolean(selectedLimit),
        submitButtonText: 'Submit',
      })}
    </BasePopup>
  );
};

CreateMissingMemberPortalAccessPopup.propTypes = {
  onClose: PropTypes.func,
};

export default CreateMissingMemberPortalAccessPopup;
